export const IS_DEFAULT_PLAYING = 'isDefaultPlaying';
